import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useGetPartnerOffering } from "../../data/api";
import { getMembershipInfoFromLocation } from "../../data/partner_offering";
import { useQueryString } from "../../hooks";
import {
  Order,
  OrderItem,
  useLocationQueryMaybe,
  useOrderQuery,
} from "../../offering/api";
import { PartnerConfig } from "../../offering/partner_config";
import { TemplateMembershipOfferingConfirmOrderBaseV2 } from "./template_offering_confirm_order_base";
import { getPartnerOfferingName } from "@/offering/get_partner_offering_name";

interface TemplateOfferingConfirmOrderMembershipParams {
  orderID: string;
  offeringID: string;
}

interface TemplateOfferingCheckoutQueryParams {
  locationID: string;
}

interface TemplateOfferingConfirmOrderMembershipProps {
  partnerConfig: PartnerConfig;
  confirmationMessage?: (
    order: Order,
    orderItem: OrderItem | undefined
  ) => React.ReactNode;
}

export function TemplateOfferingConfirmOrderMembership(
  props: TemplateOfferingConfirmOrderMembershipProps
) {
  const { partnerConfig, confirmationMessage } = props;
  const pageParams = useParams<TemplateOfferingConfirmOrderMembershipParams>();
  const queryParams = useQueryString<TemplateOfferingCheckoutQueryParams>();

  const partnerOfferingID = pageParams.offeringID;
  const partnerOffering = useGetPartnerOffering(partnerOfferingID);
  const order = useOrderQuery(pageParams.orderID);
  const orderItem = order.orderItems[0];
  if (!orderItem) {
    throw new Error("Invalid order");
  }

  const location = useLocationQueryMaybe(queryParams.locationID);

  const selectedMembership = useMemo(
    () =>
      getMembershipInfoFromLocation(
        partnerOffering.offeringLocations,
        location?.id
      ),
    [location, partnerOffering.offeringLocations]
  );

  return (
    <TemplateMembershipOfferingConfirmOrderBaseV2
      partnerOfferingID={partnerOfferingID}
      partnerOffering={partnerOffering}
      offeringName={getPartnerOfferingName(partnerOffering)}
      partnerConfig={partnerConfig}
      confirmationMessage={confirmationMessage}
      order={order}
      location={location}
      locatableType={selectedMembership?.locatableType || "Location"}
    />
  );
}
